<div class="building-info"
  *ngIf="building; else nobuilding"
  [nbPopover]="popover"
  [nbPopoverTrigger]="'hover'"
  [nbPopoverPlacement]="'bottom'">
  {{building().baseData.sectionText}}
</div>

<ng-template #nobuilding>
  <div class="no-building">kein Gebäude</div>
</ng-template>

<ng-template #popover>
  <wr-building-popover [buildingId]="building().id" [disableLink]="disableLink"></wr-building-popover>
</ng-template>
